{
  "features": {
    "config": {
      "title": "Companion of the Lamb",
      "subtitle": "Twitch integration configuration",
      "no-affiliate-or-partner-error": "This feature is only available for Twitch affiliates and partners.",
      "sections": {
        "info": {
          "moreInfo": "For a quick setup guide and overview of the features of this integration, see"
        },
        "channelPointRewards": {
          "title": "Channel Points rewards",
          "setupPrompt": "You will need to grant the Extension permission to create the Channel Points rewards necessary for the Twitch integration.",
          "setupSuccess": "Your Channel Points rewards are set up correctly. To manage the reward cost, go to",
          "channelPointsSettingsLink": "your Channel Points settings page.",
          "reconnectPrompt": "If you are experiencing issues with Channel Points rewards not working properly, try",
          "reconnectLink": "setting them up again.",
          "actions": {
            "setUpRewards": "Set up Channel Points rewards"
          }
        },
        "followerMessageModeration": {
          "title": "Follower message moderation",
          "description": "Viewers will be able to redeem a Channel Points reward to show a speech bubble with a message above their in-game follower. You can choose to manually moderate these messages before they show up in the game.",
          "autoApprovalOption": "Automatically approve all follower messages",
          "manualModerationOption": "Manually approve follower messages",
          "manualModerationHelpText": "To access the follower message moderation, go to the Cult of the Lamb tile in your Stream Manager."
        },
        "totem": {
          "title": "Totem reward",
          "totemSetupPrompt": "You will need to grant the Extension permission to create the Channel Points reward for the in-game Twitch Totem to work.",
          "totemSetupSuccess": "Your totem is set up correctly. To manage the reward cost, go to",
          "channelPointsSettingsLink": "your Channel Points settings page.",
          "totemReconnectPrompt": "If you are experiencing issues with Totem contributions not working properly, try",
          "totemReconnectLink": "reconnecting your totem.",
          "actions": {
            "setUpTotem": "Set up Totem"
          }
        },
        "premiumSkins": {
          "title": "Premium follower skins",
          "description": "Using this extension, your viewers will be able to appear in-game as followers. They will be able to customise their followers, including the use of Bits for premium skins. Select the amount of Bits for a premium skin, or you can choose to keep them free to allow anyone to use these skins.",
          "noBitsOption": "No Bits, I want free premium skins for my viewers",
          "bitsFeatureNotAvailable": "Your channel cannot use Bits. Your viewers will be able to select any skin they like without using Bits."
        }
      },
      "actions": {
        "save": "Save changes"
      }
    },
    "liveConfig": {
      "sections": {
        "followerMessageModeration": {
          "title": "Follower Messages",
          "introTextNoModerationRequired": "The integration is configured to automatically allow all follower messages to appear in the game automatically. If you would like to moderate them manually before they show up, enable the moderation setting in the Extension configuration.",
          "introText": "Any follower messages redeemed through Channel Points that require moderation will appear here.",
          "emptyQueueText": "No messages require moderation at this time.",
          "actions": {
            "approveMessage": "Approve",
            "denyMessage": "Deny"
          }
        }
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "Join {{channelName}}'s Cult!",
        "subtitle": "You won the raffle!",
        "timeRemaining": "Time remaining: {{time}}",
        "message": "Joining our cult has plenty of advantages: the chance to grow extra demonic appendages, the honor of dedicating every living second to the Cult of the Lamb, and the glory of possibly being sacrificed!",
        "viewerLinkCta": "To enter, please {share your identity}.",
        "existingFollowerMessage": "You have already joined {{channelName}}'s Cult and cannot create a new follower.",
        "actions": {
          "joinRaffle": "I want to join the Cult",
          "joinRaffleViewerHasAlreadyJoined": "You have joined the raffle",
          "dismissRaffle": "No thanks, I'm out",
          "dismissRaffleViewerHasAlreadyJoined": "Close",
          "permanentlyDismissRaffle": "Close and don't show again"
        },
        "raffleJoinedMessage": "Your willingness is appreciated. If you are chosen to join the Cult, you will be informed soon. You may close this window."
      },
      "followerBuilder": {
        "title": "Create your follower",
        "steps": {
          "intro": {
            "message": "You've joined the Cult! The follower you create here will appear in-game. Keep in mind that your follower will eventually die, but at least it was for a greater cause.",
            "actions": {
              "goToNextStep": "Create your follower"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "Continue"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "Back to skins",
              "goToNextStep": {
                "variationsForSkin": "Continue",
                "noVariationsForSkin": "Create my follower"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "Back to colors",
              "goToNextStep": "Create my follower"
            }
          }
        }
      }
    },
    "followerGallery": {
      "title": "Cult Followers",
      "noFollowersText": "This Cult has no followers yet.",
      "selection_event_prompt_by_reason": {
        "SACRIFICE": "Vote on a follower to sacrifice!",
        "DEMON": "Vote on a follower to convert to a Demon!",
        "PRISON": "Vote on a follower to imprison!",
        "MISSIONARY": "Vote on a follower to send on a missionary mission!",
        "CONFESSION":  "Vote on a follower to take confession!",
        "FOLLOWER_TO_GAIN_XP": "Vote on a follower to gain experience!",
        "HEALING_BAY":  "Vote on a follower to heal!",
        "SACRIFICE_TO_NIGHT_FOX": "Vote on a follower to sacrifice to Night Fox!",
        "SACRIFICE_TO_MIDAS":  "Vote on a follower to sacrifice to Midas!",
        "RITUAL_SACRIFICE": "Vote on a follower to sacrifice!",
        "RITUAL_ASCEND":  "Vote on a follower to ascend!",
        "RITUAL_ENFORCER": "Vote on a follower to become an enforcer!",
        "RITUAL_FIGHT_PIT":  "Vote on a follower to send to the fight pit!",
        "RITUAL_FUNERAL": "Vote on a follower to hold a funeral!",
        "RITUAL_RESURRECT":  "Vote on a follower to resurrect!",
        "RITUAL_MARRY": "Vote on a follower to marry!",
        "BED":  "Vote on a follower to go to sleep!"
      },
      "selection_event_prompt_fallback": "Select a follower!"
    },
    "helpOrHinder": {
      "help": "help",
      "hinder": "hinder",
      "hhVotingFlyout": {
        "title": "Help or Hinder",
        "message": "Cast your vote",
        "timeRemaining": "Time remaining: {{time}}",
        "voteCount": "{{amount}} votes"
      },
      "outcomeVotingFlyout": {
        "title": "Cast your vote to {{helpOrHinder}} {{channelName}}",
        "timeRemaining": "Time remaining: {{time}}"
      }
    }
  }
}
